import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  API_URL_WITH_API,
  IDENTITY_API_URL_WITH_API,
} from '../utils/Constants';

export type AuthenticationResult = {
  readonly id: string;
  readonly userName: string;
  readonly token: string;
  readonly refreshToken: string;
  readonly roleId: string;
  readonly clinicIds: readonly string[];
};

export interface LoginRequest {
  readonly userName: string;
  readonly password: string;
}

export interface RegisterRequest {
  readonly userName: string;
  readonly email: string | null;
  readonly password: string;
}

export interface RegisterResponse {
  readonly errors: ReadonlyArray<{
    readonly code: string;
    readonly description: string;
  }>;
}

export type RefreshTokenRequest = {
  readonly refreshToken: string;
};

export const authApi = createApi({
  reducerPath: 'authAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: IDENTITY_API_URL_WITH_API,
  }),
  endpoints: (builder) => ({
    login: builder.mutation<AuthenticationResult, LoginRequest>({
      query: (credentials) => ({
        url: 'authorization/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    logout: builder.mutation<void, RefreshTokenRequest>({
      query: (request) => ({
        url: 'authorization/logout',
        method: 'POST',
        body: request,
      }),
    }),
    register: builder.mutation<void, RegisterRequest>({
      query: (credentials) => ({
        url: `${API_URL_WITH_API}user/register`,
        method: 'POST',
        body: credentials,
      }),
    }),
  }),
});

export const { useLoginMutation, useLogoutMutation, useRegisterMutation } =
  authApi;
